import { twMerge } from 'tailwind-merge'
import { defineTheme } from '../utils'

export const laguna = defineTheme({
  menuTitleBlock: {
    title: 'text-center font-[base-mono-narrow] text-3xl text-primary uppercase sm:text-6xl',
  },
  themeLogo: {
    image: 'h-24 w-50 max-w-60 bg-[url(/images/logos/laguna.svg)] bg-contain bg-center bg-no-repeat object-contain',
  },
  menuCategory: {
    title: 'text-secondary uppercase underline',
  },
  menuItem: {
    dinner: {
      base: 'grid grid-cols-[1fr_auto] gap-x-2',
      title: 'col-start-1 row-start-1 inline font-[base-mono-narrow] font-semibold',
      description: 'col-start-1 row-start-2 mt-1 text-sm',
      priceList: 'col-start-2 row-span-3 row-start-1 self-start text-right',
      priceItem: 'flex justify-end gap-1 text-sm',
      icons: 'col-start-1 row-start-3 mt-1',
      label: 'mt-2 rounded bg-white py-1 text-center text-secondary',
    },
    drinks: {
      base: 'grid grid-cols-[1fr_auto] gap-x-2',
      title: 'col-start-1 row-start-1 inline font-[base-mono-narrow] font-semibold',
      description: 'col-start-1 row-start-2 mt-1 text-sm',
      priceList: 'col-start-2 row-span-3 row-start-1 self-start text-right',
      priceItem: 'flex justify-end gap-1 text-sm',
      icons: 'col-start-1 row-start-3 mt-1',
      label: 'mt-2 rounded bg-white py-1 text-center text-secondary',
    },
  },
  page: {
    container: twMerge([
      'pl-23 md:pl-34',
      'after:fixed after:inset-0 after:-z-10 after:w-18 after:bg-[url(/images/laguna_bg.jpg)]  md:after:w-29.75',
    ]),
    menuSection: twMerge([
      'pl-23 md:pl-34',
      'after:fixed after:inset-0 after:-z-10 after:w-18 after:bg-[url(/images/laguna_bg.jpg)]  md:after:w-29.75',
    ]),
    heading: 'font-[base-mono-narrow] text-6xl text-secondary uppercase',
  },
  languageButton: {
    base: 'rounded border px-4 py-2 text-center hover:shadow-lg',
  },
  allergiesList: {
    base: 'pl-23 md:pl-34',
  },
  menuSubCategory: {
    title: 'font-bold uppercase underline',
    base: 'space-y-4',
  },
  menuTextBlock: {
    base: 'bg-secondary p-4 text-center font-bold text-black uppercase',
  },
  filterBar: {
    bar: 'bg-secondary text-white',
    checkbox: 'accent-secondary',
    closeButton: 'bg-primary text-white hover:bg-primary/60',
    masterItem: 'text-black',
    itemLabel: 'text-black',
    popoverTitle: 'text-white',
    popoverHeader: 'bg-secondary',
  },
})
